// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/eye_color.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/eye_color.proto.
 */
export const file_general_eye_color: GenFile = /*@__PURE__*/
  fileDesc("ChdnZW5lcmFsL2V5ZV9jb2xvci5wcm90bxIOcHJvdG9zLmdlbmVyYWwqtwEKCEV5ZUNvbG9yEhUKEUVZRV9DT0xPUl9VTktOT1dOEAASEgoORVlFX0NPTE9SX0JMVUUQARITCg9FWUVfQ09MT1JfQlJPV04QAhISCg5FWUVfQ09MT1JfR1JBWRADEhMKD0VZRV9DT0xPUl9CTEFDSxAEEhMKD0VZRV9DT0xPUl9IQVpFTBAFEhgKFEVZRV9DT0xPUl9CTFVFX0dSRUVOEAYSEwoPRVlFX0NPTE9SX0dSRUVOEAdiBnByb3RvMw");

/**
 * @generated from enum protos.general.EyeColor
 */
export enum EyeColor {
  /**
   * @generated from enum value: EYE_COLOR_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: EYE_COLOR_BLUE = 1;
   */
  BLUE = 1,

  /**
   * @generated from enum value: EYE_COLOR_BROWN = 2;
   */
  BROWN = 2,

  /**
   * @generated from enum value: EYE_COLOR_GRAY = 3;
   */
  GRAY = 3,

  /**
   * @generated from enum value: EYE_COLOR_BLACK = 4;
   */
  BLACK = 4,

  /**
   * @generated from enum value: EYE_COLOR_HAZEL = 5;
   */
  HAZEL = 5,

  /**
   * @generated from enum value: EYE_COLOR_BLUE_GREEN = 6;
   */
  BLUE_GREEN = 6,

  /**
   * @generated from enum value: EYE_COLOR_GREEN = 7;
   */
  GREEN = 7,
}

/**
 * Describes the enum protos.general.EyeColor.
 */
export const EyeColorSchema: GenEnum<EyeColor> = /*@__PURE__*/
  enumDesc(file_general_eye_color, 0);

